import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreferencesState {
  defaultToStylus: boolean;
}

const initialState: PreferencesState = {
  defaultToStylus: false,
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setDefaultToStylus: (state, action: PayloadAction<boolean>) => {
      state.defaultToStylus = action.payload;
    },
    resetPreferences: (state) => {
      state.defaultToStylus = false;
    },
  },
});

export const { setDefaultToStylus, resetPreferences } = preferencesSlice.actions;
export default preferencesSlice.reducer;